/// <amd-module name="SuiteCommerce.CookieConsent.CookiesHandler.Cookies.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.CookieConsent.CookiesHandler.Cookies.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CookieModelAttributes;
    (function (CookieModelAttributes) {
        CookieModelAttributes["ANALYTICS"] = "ANALYTICS";
        CookieModelAttributes["PERFORMANCE"] = "PERFORMANCE";
        CookieModelAttributes["THIRDPARTIES"] = "THIRDPARTIES";
    })(CookieModelAttributes || (CookieModelAttributes = {}));
    var CookiesModel = /** @class */ (function (_super) {
        __extends(CookiesModel, _super);
        function CookiesModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(CookiesModel.prototype, "analyticsCookie", {
            get: function () {
                return this.get(CookieModelAttributes.ANALYTICS);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CookiesModel.prototype, "performanceCookie", {
            get: function () {
                return this.get(CookieModelAttributes.PERFORMANCE);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(CookiesModel.prototype, "thirdPartiesCookie", {
            get: function () {
                return this.get(CookieModelAttributes.THIRDPARTIES);
            },
            enumerable: true,
            configurable: true
        });
        CookiesModel.prototype.setAnalyticsCookie = function (cookieValue) {
            this.set(CookieModelAttributes.ANALYTICS, cookieValue);
        };
        CookiesModel.prototype.setPerformanceCookie = function (cookieValue) {
            this.set(CookieModelAttributes.PERFORMANCE, cookieValue);
        };
        CookiesModel.prototype.setThirdPartiesCookie = function (cookieValue) {
            this.set(CookieModelAttributes.THIRDPARTIES, cookieValue);
        };
        return CookiesModel;
    }(Backbone_1.Model));
    exports.CookiesModel = CookiesModel;
});
